// 区分当前环境
function checkEnv () {
    // 默认为端内环境
    let _env = 'innerPhone'
    if(/MicroMessenger/i.test(window.navigator.userAgent)) {
        _env = 'wx'
    }
    return _env
}
const environment = checkEnv();
export default {
    environment,
}